import { render, staticRenderFns } from "./Qna.vue?vue&type=template&id=92658228&scoped=true"
import script from "./Qna.vue?vue&type=script&lang=ts"
export * from "./Qna.vue?vue&type=script&lang=ts"
import style0 from "./Qna.vue?vue&type=style&index=0&id=92658228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92658228",
  null
  
)

export default component.exports